import { timeline } from '@/lib/data';

export default function TimelineModule() {
  return (
    <div className="relative border-l-2 border-[#D4D4D4] ml-2 pl-6">
      {timeline.map((item, i) => (
        <div key={i} className="relative pb-8">
          <div
            className={`absolute -left-[31px] top-1.5 w-3 h-3 circle-avatar border-2 border-white ${
              item.isKeyMoment ? 'bg-[#C8102E]' : 'bg-[#D4D4D4]'
            }`}
          />
          <div className="font-['IBM_Plex_Sans',system-ui,sans-serif] font-bold text-[11px] tracking-[0.05em] text-[#6B6B6B] mb-1 uppercase">
            {item.date}
          </div>
          <h4
            className={`font-['Playfair_Display',Georgia,serif] font-bold mb-1 ${
              item.isKeyMoment ? 'text-[16px] text-[#0D0D0D]' : 'text-[14px] text-[#2D2D2D]'
            }`}
          >
            {item.headline}
          </h4>
          <p className="font-['IBM_Plex_Sans',system-ui,sans-serif] text-[13px] text-[#6B6B6B] leading-[1.5]">
            {item.context}
          </p>
        </div>
      ))}
    </div>
  );
}
